import React from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { IOSSwitch } from '../IOSSwitch'

interface Props {
  name?: string
  /** Omit for a bare switch whose meaning is given by its card; then pass `ariaLabel`. */
  label?: string
  /** Accessible name for a switch with no visible `label`. */
  ariaLabel?: string
  description?: string
  checked?: boolean
  disabled?: boolean
  onChange(event: React.ChangeEvent<HTMLInputElement>): void
}

/**
 * The dashboard's iOS-style toggle, with the label (and its optional description) to its right
 * so a stack of switches reads as a list.
 */
export const BasicSwitch = ({
  name,
  label,
  ariaLabel,
  description,
  checked,
  disabled,
  onChange,
}: Props) => {
  return (
    <label css={tw`flex cursor-pointer flex-row items-start gap-3`}>
      <IOSSwitch
        name={name}
        checked={Boolean(checked)}
        onChange={onChange}
        disabled={disabled}
        inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
        css={tw`mt-[-1px] shrink-0`}
      />
      {label ? (
        <div css={tw`flex min-w-0 flex-col`}>
          <Typography variant="h6" css={tw`text-shades-1000`}>
            {label}
          </Typography>
          {description ? (
            <Typography variant="body2" css={tw`text-shades-500`}>
              {description}
            </Typography>
          ) : null}
        </div>
      ) : null}
    </label>
  )
}
